import { handleBookCall, requestEarlyAccess } from "src/shared/utils";

import { PricingCardType, PricingCards } from "../config/types";

export const pricingCardsData: Record<PricingCards, PricingCardType> = {
  [PricingCards.START]: {
    plan: "Start Plan",
    title: "Experience the Magic",
    subtitle:
      "Best for individuals looking to eliminate friction and elevate their daily writing.",
    price: "Free",
    features: [
      {
        title: "Stop the Copy-Paste Cycle",
        description:
          "Create and save up to 3 custom prompts for your most common tasks",
      },
      {
        title: "Save Your 3 Favorite Prompts",
        description:
          "Create and save up to 3 custom prompts for your most common tasks",
      },
      {
        title: "Create 3 Programmable Commands",
        description:
          "Build up to 3 personal shortcuts (e.g., sum::) for one-click summaries or translations.",
      },
      {
        title: "Seamless Shortcut Integration",
        description: "Instantly access AI in any application on your computer.",
      },
      {
        title: "Connect Your Own API Key",
        description:
          "Use your preferred AI model by adding your own API key (e.g., Gemini, OpenAI).",
      },
    ],
    ctaLabel: "Request Early Access",
    ctaAction: requestEarlyAccess,
    footerNote: "Join the waitlist for an invite token",
  },
  [PricingCards.PRO]: {
    plan: "Pro Plan",
    badge: "Most popular",
    title: "Master Your Workflow",
    subtitle:
      "Best for professionals who demand customization to save hours every week.",
    price: "$11.95/month",
    features: [
      {
        title: "Unlimited Custom Prompts",
        description:
          "Build a powerful, personal library of prompts for every conceivable task.",
      },
      {
        title: "Unlimited Programmable Commands",
        description:
          "Automate your entire writing process with an infinite number of custom shortcuts.",
      },
      {
        title: "Centralized Prompt Hub",
        description:
          "A dedicated library to create, manage, tag, and instantly search all your prompts.",
      },
      {
        title: "Full Generation History",
        description:
          "Access and reuse all your past AI-generated text at any time.",
      },
      {
        title: "Advanced Model Configuration",
        description:
          "Fine-tune your experience by choosing different AI models and configuring embedding settings for context-aware results.",
      },
      {
        title: "Access to All Future Updates",
        description:
          "Stay on the cutting edge with every new feature we release.",
      },
    ],
    ctaLabel: "Request Early Access",
    ctaAction: requestEarlyAccess,
    footerNote: "Get priority access to the Pro trial",
    upcomingTitle: "Upcoming features",
    upcomingSubtitle:
      "As a Pro user, you'll get immediate access to these powerful features as they are released",
    upcomingItems: [
      {
        title: "Agentic Workflow Integration",
        description:
          "Go beyond single commands. Build and trigger complex, multi-step AI chains directly within the tool or via enhanced n8n/Zapier integrations for true end-to-end automation.",
        icon: "true",
      },
    ],
  },
  [PricingCards.ENTERPRISE]: {
    plan: "Enterprise",
    title: "Transform Your Team's Productivity",
    subtitle:
      "Best for businesses and teams requiring a secure, scalable, and fully customized AI solution with a dedicated strategic partner.",
    price: "Let’s Talk",
    features: [
      {
        title: "Custom AI Agent & Chatbot Solutions",
        description:
          "We design and build everything from internal GenAI knowledge chatbots to sophisticated, multi-agent systems.",
      },
      {
        title: "Secure AI Architecture & Deployment",
        description:
          "We build GDPR-compliant Retrieval-Augmented Generation (RAG) systems that work with your sensitive company data in your own cloud.",
      },
      {
        title: "Intelligent Process & Workflow Automation",
        description:
          "We automate your core business operations via multi-step agentic workflows (n8n, LangGraph) that integrate directly with SAP, Salesforce etc.",
      },
      {
        title: "Advanced AI Model Customization & R&D",
        description:
          "We provide elite R&D to fine-tune (LoRA/QLoRA) foundation models on your data, developing proprietary AI.",
      },
    ],
    ctaLabel: "Book a Call with Sven Badalyan",
    ctaAction: handleBookCall,
    footerNote: "Let's transform your company to the AI Agentic era",
  },
};
